/**
 * UI element: Cookie consent alert.
 * requires: jquery, bootstrap
 * @deprecated use CookieConsentBanner for BS5 compatibility
 */
var springSpace = springSpace || {};
springSpace.cookieConsent = springSpace.cookieConsent || {};

/**
 *  Cookie consent header/footer alert.
 *  @param {Object} config array of configuration parameters
 *
 */
springSpace.cookieConsent.alert = function (config) {
    /**
     * Set configuration properties.
     *
     * @param {Object} config
     * @param {String} config.placement Placement position for alert 'top' or 'bottom'. Default = 'bottom'.
     * @param {String} config.aria_label the aria_label message for accessibility. Default = 'User Privacy Alert'
     * @param {Number} config.cookie_exp_days Number of days after which 'accepted' cookie expires. Default = 180.
     * @param {Function} config.read_more_callback Callback function that gets bound to 's-ui-cc-read-more-link'.
     * @param {String} config.consent_message Text of alert message.
     */
    this.setConfig = function (config) {
        if (typeof(config) == 'undefined') {
            config = {};
        }

        var okayLabel = ((config.okay) ? config.okay : 'OK');

        this.placement_opts = ['bottom', 'top'];

        // Set config.
        this.placement = (this.placement_opts.indexOf(config.placement) !== -1) ? config.placement : 'bottom';
        this.cookie_name = 'springy_cookie_consent';
        this.cookie_notice_accepted = 'ok';
        this.cookie_exp_days = (config.cookie_exp_days) ? config.cookie_exp_days : 180;
        this.read_more_callback = (config.read_more_callback) ? config.read_more_callback : function() {};

        this.aria_label = config.aria_label || 'User Privacy Alert';
        this.fade_in = 500;
        this.fade_out = 200;
        this.container_id = 's-ui-cc-container';
        this.close_button_id = 's-ui-cc-close-btn';

        //Note: this id is highly coupled. Not to mention the other ids.
        // why do the consumer apps (LibCal, LibGuides) need to render the HTML
        //with these hardcoded ids?
        this.read_more_elt_id = 's-ui-cc-read-more-link';
        this.consent_message = ( (config.consent_message) ? config.consent_message : 'By using our website you are consenting to our use of cookies in accordance with our cookie policy.');
        this.content = '<div id="' + this.container_id + '" class="container" style="display: none;">' +
            '    <aside class="navbar navbar-default navbar-fixed-' + this.placement + ' fixed-' + this.placement + '" id="s-ui-cc-navbar" aria-label="' + this.aria_label + '">' +
            '        <div id="s-ui-cc-main" class="container">' +
            '            <div class="navbar-inner navbar-content-center" id="s-ui-cc-msg-container">' +
            '                <div id="s-ui-cc-msg">' + this.consent_message + '<button id="' + this.close_button_id + '" type="button" class="btn btn-sm btn-default btn-light" data-dismiss="alert">' + okayLabel + '</button></div>' +
            '            </div>' +
            '        </div>' +
            '    </aside>' +
            '</div>';
    };

    /**
     * Check to see if the consent cookie exists.
     * @returns {boolean}
     */
    this.consentCookieAccepted = function () {
        var consent = this.getCookie(this.cookie_name);

        return (consent === this.cookie_notice_accepted);
    };

    /**
     *  Set cookie value.
     *  @param {string} cookie_name - Cookie name
     *  @param {string} value - Cookie value
     *  @param {number} exdays - Days until expiration
     */
    this.setCookie = function (cookie_name, value, exdays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + exdays);
        var cookie_value = encodeURI(value) + ((exdays === null) ? '' : '; expires=' + exdate.toUTCString());
        // only set the secure flag if the page was loaded over https
        var secureFlag = (location.protocol === 'https:') ? '; secure' : '';
        document.cookie = cookie_name + '=' + cookie_value + '; path=/; samesite=lax;' + secureFlag;

        jQuery('#' + this.container_id).hide('slow');
    };

    /**
     *  Get cookie
     *  @param {string} cookie_name - Cookie name
     *  @return {string} The cookie value
     */
    this.getCookie = function (cookie_name) {
        var i;
        var index_of_equals;
        var c_name;
        var c_value;
        var cookie_arr = document.cookie.split(";");

        for (i = 0; i < cookie_arr.length; i++) {
            index_of_equals = cookie_arr[i].indexOf("=");
            c_name = cookie_arr[i].substr(0, index_of_equals).replace(/^\s+|\s+$/g, "");

            if (c_name === cookie_name) {
                c_value = cookie_arr[i].substr(index_of_equals + 1);
                return decodeURI(c_value);
            }
        }

        return null;
    };

    /**
     *  Set the accepted cookie and close the alert.
     */
    this.handleClose = function () {
        // Set the 'accepted' cookie.
        this.setCookie(this.cookie_name, this.cookie_notice_accepted, this.cookie_exp_days);

        // Fade out the alert.
        jQuery("#" + this.container_id).fadeOut(this.fade_out);
    };

    /**
     *  Display the cookie consent alert if not already accepted.
     */
    this.handleAlert = function () {
        // If the consent cookie is not set, display the alert.
        if ( this.consentCookieAccepted() ) {
            return;
        }

        // Add the alert html to the body, pre-pended
        jQuery('body').prepend(this.content);

        // Fade in the alert.
        jQuery("#" + this.container_id).fadeIn(this.fade_in);

        // Close button handler.
        jQuery("#" + this.close_button_id).on("click", this.handleClose.bind(this));

        // Read more handler.
        // assign a href in order for the tabbing to work on this
        // do it here in common because we need to make sure the href is #. (and not generate other tickets)
        jQuery("#" + this.read_more_elt_id).attr('href', '#');
        jQuery("#" + this.read_more_elt_id).on("click", this.read_more_callback.bind(this));
    };

    this.setConfig(config);

    jQuery(document).ready(this.handleAlert.bind(this));

};
